export default __webpack_public_path__ + "static/media/l3-p2.fc0234df.svg";